import { DELETE_PERMISSION, DELETE_PERMISSION_ERROR, DELETE_PERMISSION_SUCCESS, FETCH_ALL_PERMISSIONS, FETCH_ALL_PERMISSIONS_ERROR, FETCH_ALL_PERMISSIONS_SUCCESS, FETCH_ONE_PERMISSION, FETCH_ONE_PERMISSION_ERROR, FETCH_ONE_PERMISSION_SUCCESS, SAVE_PERMISSION, SAVE_PERMISSION_ERROR, SAVE_PERMISSION_SUCCESS } from "../constants/ActionTypes";

const initialState = {
  permissions: [],
  error: null,
  loading: false,
  permission: null
}

export default function permissionsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALL_PERMISSIONS:
    case SAVE_PERMISSION:
    case DELETE_PERMISSION:
    case FETCH_ONE_PERMISSION:
      return {
        ...state,
        loading: true
      }
    case FETCH_ALL_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: action.payload
      }
    case DELETE_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: state.permissions.filter(permission => permission.permission_id !== action.payload)
      }
    case FETCH_ONE_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        permission: action.payload
      }
    case SAVE_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case FETCH_ALL_PERMISSIONS_ERROR:
    case SAVE_PERMISSION_ERROR:
    case DELETE_PERMISSION_ERROR:
    case FETCH_ONE_PERMISSION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state;
  }
} 